// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

import PageLayer from "@/Layouts/views/PageLayer";
import TechniciansWashoutLayer from "@/Washouts/views/Layers/Technicians/TechniciansWashoutLayer";
import actionsList from "@Constants/actionsList";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

const positions = supportedSystemPositions();
const POSITION = positions.SERVICE.SERVICE_TECHNICIAN;

const ServiceTechnician = () => {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_SERVICE_TECHNICIAN_COMPENSATION,
	};
	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<TechniciansWashoutLayer position={POSITION} actions={actions} />
		</PageLayer>
	);
};

export default ServiceTechnician;
